export default "__VITE_ASSET__025e8b1e__"